import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Loading } from '../../../../components/Loading';
import DownloadReportButton from '../../../../components/button/DownloadReportButton';
import { REPORT_EXECUTIVE } from '../../../../shared/Constants';
import { useSelector } from 'react-redux';
import { AccountContext } from '../../../../components/AccountContext';
import useSubscriptionExpiredRestrictions from '../../../../hooks/useSubscriptionExpiredRestrictions';

const ReportGenForm = ({ loading, exeReportId }) => {
  const { translatedTags, locale: stateLocale } = useSelector((state) => state.i18n);

  const currentAccount = useContext(AccountContext);
  const [locale, setLocale] = useState(stateLocale);
  const [printerFriendlyReport, setPrinterFriendlyReport] = useState(stateLocale);

  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  if (loading) {
    return <Loading />;
  }

  const reportParams = {
    printerFriendly: printerFriendlyReport,
    executiveReport: exeReportId,
    locale,
    account: currentAccount,
  };
  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="p-grid p-fluid">
          <div className="p-md-6 p-sm-12">
            <label htmlFor="locale" className="field-label">
              <FormattedMessage id="attrs.report_language" defaultMessage="Report Language" />
            </label>
            <Dropdown
              options={translatedTags}
              filter
              onChange={(event) => setLocale(event.value)}
              value={locale}
            />
          </div>
        </div>
        <div className="p-gid p-fluid">
          <div className="p-md-6 p-sm-12">
            <Checkbox checked={printerFriendlyReport} onChange={(e) => setPrinterFriendlyReport(e.checked)} />
            <FormattedMessage
              id="preferences.prefer-printer-friendly-reports"
              defaultMessage="I prefer printer friendly reports"
            >
              {(text) => <label htmlFor="printerFriendlyReport"> {text}</label>}
            </FormattedMessage>
          </div>
        </div>
      </div>
      <div className="p-col-12 align-center">
        <DownloadReportButton
          reportParams={reportParams}
          buttonClass="btn-sm"
          additionalClass="clearfix text-center"
          type={REPORT_EXECUTIVE}
          isDisabled={subscriptionIsExpired}
        />
      </div>
    </div>
  );
};

ReportGenForm.propTypes = {
  exeReportId: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ReportGenForm;
